import { useCallback } from 'react';

export const HAPTIC_PATTERNS = {
  START: [100],
  STOP: [100, 50, 100],
  PAUSE: [50],
  RESUME: [50],
  PEAK: [20],
  WARNING: [50, 50, 50, 50, 50],
  TAP: [10],
  SUCCESS: [50, 30, 50],
  SWIPE_SUCCESS: [30, 20, 30],
  BOUNDARY: [100],
  DRAG_START: [10],
} as const;

export const useHaptic = () => {
  const triggerHaptic = useCallback((pattern: number | readonly number[]) => {
    if ('vibrate' in navigator) {
      try {
        navigator.vibrate(pattern as number | number[]);
      } catch (error) {
        console.warn('Haptic feedback not available:', error);
      }
    }
  }, []);

  const isHapticAvailable = useCallback(() => {
    return 'vibrate' in navigator;
  }, []);

  return { triggerHaptic, isHapticAvailable };
};
